export default "__VITE_ASSET__BzYzfCxp__"